// TODO: convert to ES6 module (requires babel-plugin-add-module-exports to be used from requireJS code - https://babeljs.io/docs/plugins/transform-es2015-modules-commonjs/)
define((require, exports, module) => {
    const CurrentUserModel = require('system/models/CurrentUserModel');

    const currentUser = new CurrentUserModel();

    module.exports = currentUser;
});
